import { object, string, ref } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default (data = {}, { isNewRecord }) => {
    const { PASSWORDS_DONT_MATCH, REQUIRED_TEXT } = getValidationTexts();

    let validationRules = {
        first_name: string().required(REQUIRED_TEXT).nullable(),
        last_name: string().required(REQUIRED_TEXT).nullable(),
        email: string().required(REQUIRED_TEXT).nullable(),
    };

    if (isNewRecord)
        validationRules = {
            ...validationRules,
            password: string().min(8).required(REQUIRED_TEXT).nullable(),
            confirm_password: string()
                .min(8)
                .required(REQUIRED_TEXT)
                .oneOf([ref('password'), null], PASSWORDS_DONT_MATCH)
                .nullable(),
        };

    try {
        const values = object().shape(validationRules).validateSync(data, {
            abortEarly: false,
        });
        return { values, errors: {} };
    } catch (errors) {
        return {
            values: {},
            errors: errors.inner.reduce((allErrors, currentError) => {
                return {
                    ...allErrors,
                    [currentError.path]: {
                        type: currentError.type ?? 'validation',
                        message: currentError.message,
                    },
                };
            }, {}),
        };
    }
};
